export const UserIcon = ({ color = "#DBBE78", size = 16, ...props }) => (
    <svg
        width={size}
        height={size * (17 / 16)}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="8" cy="8.5" r="8" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0298 13.7577C15.2568 12.3517 16 10.5127 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 10.5675 0.784256 12.4517 2.0715 13.8716C3.23876 12.4991 6.36479 11.8088 8.102 11.8088C9.7905 11.8088 12.791 12.461 14.0298 13.7577ZM11.3452 7.00841C11.3452 8.77654 9.89389 10.2087 8.102 10.2087C6.31011 10.2087 4.85876 8.77654 4.85876 7.00841C4.85876 5.24027 6.31011 3.80816 8.102 3.80816C9.89389 3.80816 11.3452 5.24027 11.3452 7.00841Z"
            fill={color}
        />
    </svg>
);
